import React from 'react';

interface EditableFieldRowProps {
  label: string;
  value?: string;
  onChange: (value: string) => void;
  editing: boolean;
  placeholder?: string;
}

export function EditableFieldRow({ label, value, onChange, editing, placeholder }: EditableFieldRowProps) {
  const textareaRef = React.useRef<HTMLTextAreaElement>(null);

  const autoResize = (el: HTMLTextAreaElement | null) => {
    if (!el) return;
    el.style.height = "auto";
    el.style.height = el.scrollHeight + "px";
  };

  React.useEffect(() => {
    if (textareaRef.current) autoResize(textareaRef.current);
  }, [value]);

  if (editing) {
    return (
      <div className="flex-start gap-5 editable-field-row-edit">
        <div className="label-sm ls-wide editable-field-label">{label}</div>
        <textarea
          ref={textareaRef}
          value={value || ""}
          onChange={e => { onChange(e.target.value); autoResize(e.target); }}
          placeholder={placeholder || "Enter " + label.toLowerCase()}
          rows={1}
          className="flex-1 rounded text-base ff-secondary text-dark bg-card overflow-hidden lh-normal box-border outline-none pad-md border-slate-25 editable-field-textarea"
        />
      </div>
    );
  }

  return (
    <div className="flex items-start gap-5 editable-field-row-view">
      <div className="label-sm ls-wide editable-field-label-view">{label}</div>
      <div className={`text-base lh-normal flex-1 ${value ? "field-value-filled" : "field-value-empty"}`}>
        {value || placeholder || "Not set"}
      </div>
    </div>
  );
}
